module.exports = __webpack_public_path__ + "img/icon-pix-logo.5bc253e8.svg";